import { SiteContainer } from "@dash/nav";
import { useTheme } from "@emotion/react";
import { API_URL, CRM_URL, DOCS_URL, INVOICES_URL, POINTS_URL, QR_SYNC_URL, useConfig } from "@megarax/dev-config";
import { useContext, useEffect, useState } from "react";

import { IamAuthContext } from "@megaron/auth-react";

import { MegaraxNav } from "./nav/MegaraxNav";
import { WelcomeScreen } from "./WelcomeScreen";

const environmentTemplate = process.env["NX_PUBLIC_ENVIRONMENT_TEMPLATE"];

type Props = {
  children?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  logo?: React.ReactNode;
  backgroundImageSrc?: string;
  className?: string;
  bypassAuth?: boolean;
};

export const MegaraxWebappContainer: React.FunctionComponent<Props> = (props) => {
  const authCtx = useContext(IamAuthContext);

  const theme = useTheme();

  const { config } = useConfig();
  const { apiUrl, crmUrl, docsUrl, invoicesUrl, pointsUrl, qrSyncUrl } = config;

  const [isProductionUsed, setIsProductionUsed] = useState<boolean>(false);

  useEffect(() => {
    if (
      apiUrl === API_URL ||
      crmUrl === CRM_URL ||
      docsUrl === DOCS_URL ||
      invoicesUrl === INVOICES_URL ||
      pointsUrl === POINTS_URL ||
      qrSyncUrl === QR_SYNC_URL
    ) {
      setIsProductionUsed(true);
      return;
    }

    setIsProductionUsed(false);
  }, [apiUrl, crmUrl, docsUrl, invoicesUrl, pointsUrl, qrSyncUrl]);

  useEffect(() => {
    updateThemeColor(theme.colors.primary);
  }, [theme.colors.primary]);

  return (
    <SiteContainer
      className={props.className}
      welcomeScreen={
        authCtx.iamUser || props.bypassAuth ? undefined : (
          <WelcomeScreen logo={props.logo} title={props.title} subtitle={props.subtitle} />
        )
      }
      backgroundImageSrc={props.backgroundImageSrc}
      nav={<MegaraxNav showProductionEnvAlert={isProductionUsed && !environmentTemplate} />}
    >
      {props.children}
    </SiteContainer>
  );
};

const updateThemeColor = (color: string) => {
  const metaThemeColor = document.querySelector("meta[name=theme-color]");
  if (metaThemeColor) {
    metaThemeColor.setAttribute("content", color);
  } else {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "theme-color");
    meta.setAttribute("content", color);
    document.head.appendChild(meta);
  }
};
